<ng-multiselect-dropdown name="mediaType" 
style="display: block; background-color: white; color:black"
  class="omargin-left" [placeholder]="'select'" [(ngModel)]="selectedItem"
  [settings]="dropdownSettings" [data]="singleSelectItems" (onSelect)="onSelect($event)" (onDeSelect)="onDeSelect($event)">
</ng-multiselect-dropdown>